import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 bg-success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-light m-0 fs-2" }, " Course Wise Training Activities Report ")
    ])
  ])
], -1)
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table-responsive m-0 sticky" }
const _hoisted_4 = { class: "row w-100 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Course Wise Training Activities Report")
  ])
], -1)
const _hoisted_6 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_14 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " SN "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","max-width":"150px !important"},
      rowspan: "2",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "3",
      class: "align-middle border border-gray-400 sticky-header"
    }, [
      /*#__PURE__*/_createTextVNode(" Total Target "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" (As Per Contract) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "5",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "5",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "5",
      class: "align-middle border border-gray-400 sticky-header"
    }, " Job Placement "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      colspan: "5",
      class: "align-middle border border-gray-400 sticky-header"
    }, " JP % of Certified ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " New Entrant "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Upskills "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " New Entrant "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Upskills "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " New Entrant "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Upskills "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " New Entrant "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Upskills "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " New Entrant "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Upskills "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400 sticky-header"
    }, " Female ")
  ])
], -1)
const _hoisted_16 = { style: {} }
const _hoisted_17 = { class: "fw-bolder bg-light" }
const _hoisted_18 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_19 = {
  key: 0,
  class: "fw-bolder bg-light"
}
const _hoisted_20 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "border border-gray-400 text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_27 = { style: {"font-weight":"bold"} }
const _hoisted_28 = { style: {"font-weight":"bold"} }
const _hoisted_29 = { style: {"font-weight":"bold"} }
const _hoisted_30 = { style: {"font-weight":"bold"} }
const _hoisted_31 = { style: {"font-weight":"bold"} }
const _hoisted_32 = { style: {"font-weight":"bold"} }
const _hoisted_33 = { style: {"font-weight":"bold"} }
const _hoisted_34 = { style: {"font-weight":"bold"} }
const _hoisted_35 = { style: {"font-weight":"bold"} }
const _hoisted_36 = { style: {"font-weight":"bold"} }
const _hoisted_37 = { style: {"font-weight":"bold"} }
const _hoisted_38 = { style: {"font-weight":"bold"} }
const _hoisted_39 = { style: {"font-weight":"bold"} }
const _hoisted_40 = { style: {"font-weight":"bold"} }
const _hoisted_41 = { style: {"font-weight":"bold"} }
const _hoisted_42 = { style: {"font-weight":"bold"} }
const _hoisted_43 = { style: {"font-weight":"bold"} }
const _hoisted_44 = { style: {"font-weight":"bold"} }
const _hoisted_45 = { style: {"font-weight":"bold"} }
const _hoisted_46 = { style: {"font-weight":"bold"} }
const _hoisted_47 = { style: {"font-weight":"bold"} }
const _hoisted_48 = { style: {"font-weight":"bold"} }
const _hoisted_49 = { style: {"font-weight":"bold"} }
const _hoisted_50 = {
  key: 2,
  class: "fw-bolder bg-light"
}
const _hoisted_51 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = ["href"]
const _hoisted_56 = { class: "border border-gray-400 text-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_58 = { style: {"font-weight":"bold"} }
const _hoisted_59 = { style: {"font-weight":"bold"} }
const _hoisted_60 = { style: {"font-weight":"bold"} }
const _hoisted_61 = { style: {"font-weight":"bold"} }
const _hoisted_62 = { style: {"font-weight":"bold"} }
const _hoisted_63 = { style: {"font-weight":"bold"} }
const _hoisted_64 = { style: {"font-weight":"bold"} }
const _hoisted_65 = { style: {"font-weight":"bold"} }
const _hoisted_66 = { style: {"font-weight":"bold"} }
const _hoisted_67 = { style: {"font-weight":"bold"} }
const _hoisted_68 = { style: {"font-weight":"bold"} }
const _hoisted_69 = { style: {"font-weight":"bold"} }
const _hoisted_70 = { style: {"font-weight":"bold"} }
const _hoisted_71 = { style: {"font-weight":"bold"} }
const _hoisted_72 = { style: {"font-weight":"bold"} }
const _hoisted_73 = { style: {"font-weight":"bold"} }
const _hoisted_74 = { style: {"font-weight":"bold"} }
const _hoisted_75 = { style: {"font-weight":"bold"} }
const _hoisted_76 = { style: {"font-weight":"bold"} }
const _hoisted_77 = { style: {"font-weight":"bold"} }
const _hoisted_78 = { style: {"font-weight":"bold"} }
const _hoisted_79 = { style: {"font-weight":"bold"} }
const _hoisted_80 = { style: {"font-weight":"bold"} }
const _hoisted_81 = {
  key: 4,
  class: "fw-bolder bg-light"
}
const _hoisted_82 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = ["href"]
const _hoisted_87 = { class: "border border-gray-400 text-center" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_89 = { style: {"font-weight":"bold"} }
const _hoisted_90 = { style: {"font-weight":"bold"} }
const _hoisted_91 = { style: {"font-weight":"bold"} }
const _hoisted_92 = { style: {"font-weight":"bold"} }
const _hoisted_93 = { style: {"font-weight":"bold"} }
const _hoisted_94 = { style: {"font-weight":"bold"} }
const _hoisted_95 = { style: {"font-weight":"bold"} }
const _hoisted_96 = { style: {"font-weight":"bold"} }
const _hoisted_97 = { style: {"font-weight":"bold"} }
const _hoisted_98 = { style: {"font-weight":"bold"} }
const _hoisted_99 = { style: {"font-weight":"bold"} }
const _hoisted_100 = { style: {"font-weight":"bold"} }
const _hoisted_101 = { style: {"font-weight":"bold"} }
const _hoisted_102 = { style: {"font-weight":"bold"} }
const _hoisted_103 = { style: {"font-weight":"bold"} }
const _hoisted_104 = { style: {"font-weight":"bold"} }
const _hoisted_105 = { style: {"font-weight":"bold"} }
const _hoisted_106 = { style: {"font-weight":"bold"} }
const _hoisted_107 = { style: {"font-weight":"bold"} }
const _hoisted_108 = { style: {"font-weight":"bold"} }
const _hoisted_109 = { style: {"font-weight":"bold"} }
const _hoisted_110 = { style: {"font-weight":"bold"} }
const _hoisted_111 = { style: {"font-weight":"bold"} }
const _hoisted_112 = {
  key: 6,
  class: "fw-bolder bg-light"
}
const _hoisted_113 = {
  key: 0,
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "25",
  class: "align-middle border border-gray-400"
}
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { key: 2 }
const _hoisted_117 = ["href"]
const _hoisted_118 = { class: "border border-gray-400 text-center" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, " Sub-Total ")
], -1)
const _hoisted_120 = { style: {"font-weight":"bold"} }
const _hoisted_121 = { style: {"font-weight":"bold"} }
const _hoisted_122 = { style: {"font-weight":"bold"} }
const _hoisted_123 = { style: {"font-weight":"bold"} }
const _hoisted_124 = { style: {"font-weight":"bold"} }
const _hoisted_125 = { style: {"font-weight":"bold"} }
const _hoisted_126 = { style: {"font-weight":"bold"} }
const _hoisted_127 = { style: {"font-weight":"bold"} }
const _hoisted_128 = { style: {"font-weight":"bold"} }
const _hoisted_129 = { style: {"font-weight":"bold"} }
const _hoisted_130 = { style: {"font-weight":"bold"} }
const _hoisted_131 = { style: {"font-weight":"bold"} }
const _hoisted_132 = { style: {"font-weight":"bold"} }
const _hoisted_133 = { style: {"font-weight":"bold"} }
const _hoisted_134 = { style: {"font-weight":"bold"} }
const _hoisted_135 = { style: {"font-weight":"bold"} }
const _hoisted_136 = { style: {"font-weight":"bold"} }
const _hoisted_137 = { style: {"font-weight":"bold"} }
const _hoisted_138 = { style: {"font-weight":"bold"} }
const _hoisted_139 = { style: {"font-weight":"bold"} }
const _hoisted_140 = { style: {"font-weight":"bold"} }
const _hoisted_141 = { style: {"font-weight":"bold"} }
const _hoisted_142 = { style: {"font-weight":"bold"} }
const _hoisted_143 = {
  key: 8,
  class: "border border-gray-400 text-center"
}
const _hoisted_144 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", null, "(A+B+C)", -1)
const _hoisted_146 = { style: {"font-weight":"bold"} }
const _hoisted_147 = { style: {"font-weight":"bold"} }
const _hoisted_148 = { style: {"font-weight":"bold"} }
const _hoisted_149 = { style: {"font-weight":"bold"} }
const _hoisted_150 = { style: {"font-weight":"bold"} }
const _hoisted_151 = { style: {"font-weight":"bold"} }
const _hoisted_152 = { style: {"font-weight":"bold"} }
const _hoisted_153 = { style: {"font-weight":"bold"} }
const _hoisted_154 = { style: {"font-weight":"bold"} }
const _hoisted_155 = { style: {"font-weight":"bold"} }
const _hoisted_156 = { style: {"font-weight":"bold"} }
const _hoisted_157 = { style: {"font-weight":"bold"} }
const _hoisted_158 = { style: {"font-weight":"bold"} }
const _hoisted_159 = { style: {"font-weight":"bold"} }
const _hoisted_160 = { style: {"font-weight":"bold"} }
const _hoisted_161 = { style: {"font-weight":"bold"} }
const _hoisted_162 = { style: {"font-weight":"bold"} }
const _hoisted_163 = { style: {"font-weight":"bold"} }
const _hoisted_164 = { style: {"font-weight":"bold"} }
const _hoisted_165 = { style: {"font-weight":"bold"} }
const _hoisted_166 = { style: {"font-weight":"bold"} }
const _hoisted_167 = { style: {"font-weight":"bold"} }
const _hoisted_168 = { style: {"font-weight":"bold"} }
const _hoisted_169 = {
  key: 9,
  class: "border border-gray-400 text-center"
}
const _hoisted_170 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", null, " (D+E+F+G) ", -1)
const _hoisted_172 = { style: {"font-weight":"bold"} }
const _hoisted_173 = { style: {"font-weight":"bold"} }
const _hoisted_174 = { style: {"font-weight":"bold"} }
const _hoisted_175 = { style: {"font-weight":"bold"} }
const _hoisted_176 = { style: {"font-weight":"bold"} }
const _hoisted_177 = { style: {"font-weight":"bold"} }
const _hoisted_178 = { style: {"font-weight":"bold"} }
const _hoisted_179 = { style: {"font-weight":"bold"} }
const _hoisted_180 = { style: {"font-weight":"bold"} }
const _hoisted_181 = { style: {"font-weight":"bold"} }
const _hoisted_182 = { style: {"font-weight":"bold"} }
const _hoisted_183 = { style: {"font-weight":"bold"} }
const _hoisted_184 = { style: {"font-weight":"bold"} }
const _hoisted_185 = { style: {"font-weight":"bold"} }
const _hoisted_186 = { style: {"font-weight":"bold"} }
const _hoisted_187 = { style: {"font-weight":"bold"} }
const _hoisted_188 = { style: {"font-weight":"bold"} }
const _hoisted_189 = { style: {"font-weight":"bold"} }
const _hoisted_190 = { style: {"font-weight":"bold"} }
const _hoisted_191 = { style: {"font-weight":"bold"} }
const _hoisted_192 = { style: {"font-weight":"bold"} }
const _hoisted_193 = { style: {"font-weight":"bold"} }
const _hoisted_194 = { style: {"font-weight":"bold"} }
const _hoisted_195 = {
  key: 10,
  class: "border border-gray-400 text-center"
}
const _hoisted_196 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "2"
}
const _hoisted_197 = { style: {"font-weight":"bold"} }
const _hoisted_198 = { style: {"font-weight":"bold"} }
const _hoisted_199 = { style: {"font-weight":"bold"} }
const _hoisted_200 = { style: {"font-weight":"bold"} }
const _hoisted_201 = { style: {"font-weight":"bold"} }
const _hoisted_202 = { style: {"font-weight":"bold"} }
const _hoisted_203 = { style: {"font-weight":"bold"} }
const _hoisted_204 = { style: {"font-weight":"bold"} }
const _hoisted_205 = { style: {"font-weight":"bold"} }
const _hoisted_206 = { style: {"font-weight":"bold"} }
const _hoisted_207 = { style: {"font-weight":"bold"} }
const _hoisted_208 = { style: {"font-weight":"bold"} }
const _hoisted_209 = { style: {"font-weight":"bold"} }
const _hoisted_210 = { style: {"font-weight":"bold"} }
const _hoisted_211 = { style: {"font-weight":"bold"} }
const _hoisted_212 = { style: {"font-weight":"bold"} }
const _hoisted_213 = { style: {"font-weight":"bold"} }
const _hoisted_214 = { style: {"font-weight":"bold"} }
const _hoisted_215 = { style: {"font-weight":"bold"} }
const _hoisted_216 = { style: {"font-weight":"bold"} }
const _hoisted_217 = { style: {"font-weight":"bold"} }
const _hoisted_218 = { style: {"font-weight":"bold"} }
const _hoisted_219 = { style: {"font-weight":"bold"} }
const _hoisted_220 = { class: "border border-gray-400 text-center" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Grand Total (All Tranches) ")
], -1)
const _hoisted_222 = { style: {"font-weight":"bold"} }
const _hoisted_223 = { style: {"font-weight":"bold"} }
const _hoisted_224 = { style: {"font-weight":"bold"} }
const _hoisted_225 = { style: {"font-weight":"bold"} }
const _hoisted_226 = { style: {"font-weight":"bold"} }
const _hoisted_227 = { style: {"font-weight":"bold"} }
const _hoisted_228 = { style: {"font-weight":"bold"} }
const _hoisted_229 = { style: {"font-weight":"bold"} }
const _hoisted_230 = { style: {"font-weight":"bold"} }
const _hoisted_231 = { style: {"font-weight":"bold"} }
const _hoisted_232 = { style: {"font-weight":"bold"} }
const _hoisted_233 = { style: {"font-weight":"bold"} }
const _hoisted_234 = { style: {"font-weight":"bold"} }
const _hoisted_235 = { style: {"font-weight":"bold"} }
const _hoisted_236 = { style: {"font-weight":"bold"} }
const _hoisted_237 = { style: {"font-weight":"bold"} }
const _hoisted_238 = { style: {"font-weight":"bold"} }
const _hoisted_239 = { style: {"font-weight":"bold"} }
const _hoisted_240 = { style: {"font-weight":"bold"} }
const _hoisted_241 = { style: {"font-weight":"bold"} }
const _hoisted_242 = { style: {"font-weight":"bold"} }
const _hoisted_243 = { style: {"font-weight":"bold"} }
const _hoisted_244 = { style: {"font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
              title: "Download Xlse",
              "data-v-54b12dc8": "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTrainee()))
            }, _hoisted_8),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
              title: "Download PDF",
              "data-v-54b12dc8": "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
            }, _hoisted_10),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
              title: "Print",
              "data-v-54b12dc8": "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPdf()))
            }, _hoisted_12),
            _hoisted_13
          ])
        ]),
        _createElementVNode("table", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("tbody", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tmsdashboardInfo, (info, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                _createElementVNode("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                  ])
                ]),
                (
                  info?.trancheInfo?.industry_association?.association.length >
                  0
                )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                      (
                    info?.trancheInfo?.industry_association?.association
                      .length > 0
                  )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                            (info?.trancheInfo?.id == 1)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_21, " A. Industry Associations "))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 2)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_22, " D. Industry Associations "))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 5)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_23, " H. Industry Associations "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
                  info?.trancheInfo?.industry_association?.association.length >
                  0
                )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.industry_association
                    ?.association, (data, inx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: inx,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: 
                          `${this.VUE_APP_TMS}/course-summary/2/` +
                          info?.trancheInfo?.id +
                          '/' +
                          data?.id
                        ,
                              target: "_blank",
                              class: "text-primary fw-bold fs-6 mt-2"
                            }, _toDisplayString(data?.entity_short_name), 9, _hoisted_24)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalnewentrantenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalupskillenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_upskill_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_job_place
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femal_upskill_job_place).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.percentage_of_job_placement
                          ? parseFloat(
                              data?.percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.newentrant_percentage_of_job_placement || 0) >
                        100
                          ? 100
                          : data?.newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_newentrant_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.upskill_percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_upskill_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("td", _hoisted_27, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association?.subTotalTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalUpskillTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewentrantEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewentrantFemaleEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalfemaleUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantFemaleCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_39, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalfemaleUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_40, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_41, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantFemaleJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_44, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalfemaleUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_45, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_46, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_47, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalNewEntrantFemalePercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(Number(
                        info?.trancheInfo?.industry_association
                          ?.subTotalFemaleUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.gov_org?.association.length > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                      (info?.trancheInfo?.gov_org?.association.length > 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                            (info?.trancheInfo?.id == 1)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_52, " B. Govt. Partners "))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 2)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_53, " E. Govt. Partners "))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 5)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_54, " I. Govt. Partners "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.gov_org?.association.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.gov_org?.association, (data, inx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: inx,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: 
                          `${this.VUE_APP_TMS}/course-summary/2/` +
                          info?.trancheInfo?.id +
                          '/' +
                          data?.id
                        ,
                              target: "_blank",
                              class: "text-primary fw-bold fs-6 mt-2"
                            }, _toDisplayString(data?.entity_short_name), 9, _hoisted_55)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalnewentrantenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalupskillenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_upskill_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_job_place
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femal_upskill_job_place).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.percentage_of_job_placement
                          ? parseFloat(
                              data?.percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.newentrant_percentage_of_job_placement || 0) >
                        100
                          ? 100
                          : data?.newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_newentrant_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.upskill_percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_upskill_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("td", _hoisted_58, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_59, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalNewEntrantTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_60, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalUpskillTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_61, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_62, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalNewentrantEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_63, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewentrantFemaleEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_65, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalfemaleUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_66, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_67, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_68, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantFemaleCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_69, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_70, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalfemaleUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_71, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_72, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_73, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantFemaleJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_74, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org?.subTotalUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_75, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalfemaleUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_76, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_77, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_78, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalNewEntrantFemalePercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_79, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_80, _toDisplayString(Number(
                        info?.trancheInfo?.gov_org
                          ?.subTotalFemaleUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.motor_driving?.association.length > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                      (
                    info?.trancheInfo?.motor_driving?.association.length > 0
                  )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_82, [
                            (info?.trancheInfo?.id == 1)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_83, " C. Motor Driving"))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 2)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_84, " F. Motor Driving"))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 5)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_85, " J. Motor Driving"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.motor_driving?.association.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.motor_driving
                    ?.association, (data, inx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: inx,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: 
                          `${this.VUE_APP_TMS}/course-summary/1/` +
                          info?.trancheInfo?.id +
                          '/' +
                          data?.id
                        ,
                              target: "_blank",
                              class: "text-primary fw-bold fs-6 mt-2"
                            }, _toDisplayString(data?.entity_short_name), 9, _hoisted_86)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalnewentrantenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalupskillenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_upskill_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_job_place
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femal_upskill_job_place).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.percentage_of_job_placement
                          ? parseFloat(
                              data?.percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.newentrant_percentage_of_job_placement || 0) >
                        100
                          ? 100
                          : data?.newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_newentrant_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.upskill_percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_upskill_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_87, [
                        _hoisted_88,
                        _createElementVNode("td", _hoisted_89, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving?.subTotalTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_90, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_91, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving?.subTotalUpskillTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_92, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving?.subTotalEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_93, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewentrantEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_94, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewentrantFemaleEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_95, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_96, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalfemaleUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_97, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving?.subTotalCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_98, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_99, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantFemaleCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_100, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_101, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalfemaleUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_102, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving?.subTotalJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_103, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_104, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantFemaleJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_105, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_106, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalfemaleUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_107, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_108, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_109, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalNewEntrantFemalePercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_110, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_111, _toDisplayString(Number(
                        info?.trancheInfo?.motor_driving
                          ?.subTotalFemaleUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.edc?.association.length > 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_112, [
                      (info?.trancheInfo?.edc?.association.length > 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_113, [
                            (info?.trancheInfo?.id == 1)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_114, " I. Excecutive Development Program"))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 2)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_115, " G. Excecutive Development Program"))
                              : _createCommentVNode("", true),
                            (info?.trancheInfo?.id == 5)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_116, " K. Excecutive Development Program"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.edc?.association.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo?.edc?.association, (data, inx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: inx,
                          class: "border border-gray-400 text-center"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: 
                          `${this.VUE_APP_TMS}/course-summary/2/` +
                          info?.trancheInfo?.id +
                          '/' +
                          data?.id
                        ,
                              target: "_blank",
                              class: "text-primary fw-bold fs-6 mt-2"
                            }, _toDisplayString(data?.entity_short_name), 9, _hoisted_117)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.targetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillTragetTrainee).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.enrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrantenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalnewentrantenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskillenrollment).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femalupskillenroll).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_certification).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_upskill_certification
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.job_placement).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.newentrant_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(
                          data?.femal_newentrant_job_place
                        ).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.upskill_jobplace).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(data?.femal_upskill_job_place).toLocaleString()), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.percentage_of_job_placement
                          ? parseFloat(
                              data?.percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.newentrant_percentage_of_job_placement || 0) >
                        100
                          ? 100
                          : data?.newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_newentrant_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_newentrant_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_newentrant_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.upskill_percentage_of_job_placement || 0) > 100
                          ? 100
                          : data?.upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1),
                          _createElementVNode("td", null, _toDisplayString((data?.female_upskill_percentage_of_job_placement ||
                          0) > 100
                          ? 100
                          : data?.female_upskill_percentage_of_job_placement
                          ? parseFloat(
                              data?.female_upskill_percentage_of_job_placement
                            ).toFixed(2)
                          : 0), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", _hoisted_118, [
                        _hoisted_119,
                        _createElementVNode("td", _hoisted_120, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_121, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalNewEntrantTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_122, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalUpskillTrainee
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_123, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_124, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalNewentrantEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_125, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalNewentrantFemaleEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_126, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_127, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalfemaleUpskillEnrollment
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_128, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_129, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalNewEntrantCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_130, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalNewEntrantFemaleCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_131, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_132, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalfemaleUpskillCertification
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_133, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_134, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalNewEntrantJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_135, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalNewEntrantFemaleJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_136, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_137, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalfemaleUpskillJobPlacement
                      ).toLocaleString()), 1),
                        _createElementVNode("td", _hoisted_138, _toDisplayString(Number(
                        info?.trancheInfo?.edc?.subTotalPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_139, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalNewEntrantPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_140, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalNewEntrantFemalePercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_141, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1),
                        _createElementVNode("td", _hoisted_142, _toDisplayString(Number(
                        info?.trancheInfo?.edc
                          ?.subTotalFemaleUpskillPercentageOfJobPlacement
                      ).toFixed(2)), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.id == 1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_143, [
                      _createElementVNode("td", _hoisted_144, [
                        _createElementVNode("b", null, [
                          _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                          _hoisted_145
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_146, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_147, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetNewEntrantTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_148, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetUpskillTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_149, _toDisplayString((
                      Number(info?.trancheInfo?.TotalEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_150, _toDisplayString((
                      Number(info?.trancheInfo?.TotalNewEntrantEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_151, _toDisplayString((
                      Number(
                        info?.trancheInfo?.TotalNewEntrantFemaleEnrollment
                      )
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_152, _toDisplayString((
                      Number(info?.trancheInfo?.TotalUpskillEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_153, _toDisplayString((
                      Number(info?.trancheInfo?.TotalFemaleUpskillEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_154, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificate)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_155, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateNewEntrant)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_156, _toDisplayString((
                      Number(
                        info?.trancheInfo?.TotalCertificateNewEntrantFemale
                      )
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_157, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_158, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateFemaleUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_159, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJob)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_160, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobNewEntrant)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_161, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobNewEntrantFemale)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_162, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_163, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobFemaleUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_164, _toDisplayString((
                      Number(
                        info?.trancheInfo?.Total_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_165, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_newentrant_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_166, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_Female_newentrant_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_167, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_upskill_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_168, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_upskill_female_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.id == 2)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_169, [
                      _createElementVNode("td", _hoisted_170, [
                        _createElementVNode("b", null, [
                          _createTextVNode("Total " + _toDisplayString(info?.trancheInfo?.label) + " ", 1),
                          _hoisted_171
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_172, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_173, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetNewEntrantTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_174, _toDisplayString((
                      Number(info?.trancheInfo?.TotalTargetUpskillTrainee)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_175, _toDisplayString((
                      Number(info?.trancheInfo?.TotalEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_176, _toDisplayString((
                      Number(info?.trancheInfo?.TotalNewEntrantEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_177, _toDisplayString((
                      Number(
                        info?.trancheInfo?.TotalNewEntrantFemaleEnrollment
                      )
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_178, _toDisplayString((
                      Number(info?.trancheInfo?.TotalUpskillEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_179, _toDisplayString((
                      Number(info?.trancheInfo?.TotalFemaleUpskillEnrollment)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_180, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificate)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_181, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateNewEntrant)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_182, _toDisplayString((
                      Number(
                        info?.trancheInfo?.TotalCertificateNewEntrantFemale
                      )
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_183, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_184, _toDisplayString((
                      Number(info?.trancheInfo?.TotalCertificateFemaleUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_185, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJob)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_186, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobNewEntrant)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_187, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobNewEntrantFemale)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_188, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_189, _toDisplayString((
                      Number(info?.trancheInfo?.TotalJobFemaleUpskill)
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_190, _toDisplayString((
                      Number(
                        info?.trancheInfo?.Total_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_191, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_newentrant_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_192, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_Female_newentrant_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_193, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_upskill_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_194, _toDisplayString((
                      Number(
                        info?.trancheInfo
                          ?.Total_upskill_female_percentage_of_job_placement
                      )
                    ).toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (info?.trancheInfo?.id == 5)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_195, [
                      _createElementVNode("td", _hoisted_196, [
                        _createElementVNode("b", null, "Total " + _toDisplayString(info?.trancheInfo?.parent_tranche?.label) + " (K+L+M+N) ", 1)
                      ]),
                      _createElementVNode("td", _hoisted_197, _toDisplayString(Number(
                      info?.trancheInfo?.TotalTargetTrainee
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_198, _toDisplayString(Number(
                      info?.trancheInfo?.TotalTargetNewEntrantTrainee
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_199, _toDisplayString(Number(
                      info?.trancheInfo?.TotalTargetUpskillTrainee
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_200, _toDisplayString(Number(info?.trancheInfo?.TotalEnrollment).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_201, _toDisplayString(Number(
                      info?.trancheInfo?.TotalNewEntrantEnrollment
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_202, _toDisplayString(Number(
                      info?.trancheInfo?.TotalNewEntrantFemaleEnrollment
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_203, _toDisplayString(Number(
                      info?.trancheInfo?.TotalUpskillEnrollment
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_204, _toDisplayString(Number(
                      info?.trancheInfo?.TotalFemaleUpskillEnrollment
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_205, _toDisplayString(Number(info?.trancheInfo?.TotalCertificate).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_206, _toDisplayString(Number(
                      info?.trancheInfo?.TotalCertificateNewEntrant
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_207, _toDisplayString(Number(
                      info?.trancheInfo?.TotalCertificateNewEntrantFemale
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_208, _toDisplayString(Number(
                      info?.trancheInfo?.TotalCertificateUpskill
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_209, _toDisplayString(Number(
                      info?.trancheInfo?.TotalCertificateFemaleUpskill
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_210, _toDisplayString(Number(info?.trancheInfo?.TotalJob).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_211, _toDisplayString(Number(
                      info?.trancheInfo?.TotalJobNewEntrant
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_212, _toDisplayString(Number(
                      info?.trancheInfo?.TotalJobNewEntrantFemale
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_213, _toDisplayString(Number(info?.trancheInfo?.TotalJobUpskill).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_214, _toDisplayString(Number(
                      info?.trancheInfo?.TotalJobFemaleUpskill
                    ).toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_215, _toDisplayString(Number(
                      info?.trancheInfo?.Total_percentage_of_job_placement
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_216, _toDisplayString(Number(
                      info?.trancheInfo
                        ?.Total_newentrant_percentage_of_job_placement
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_217, _toDisplayString(Number(
                      info?.trancheInfo
                        ?.Total_Female_newentrant_percentage_of_job_placement
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_218, _toDisplayString(Number(
                      info?.trancheInfo
                        ?.Total_upskill_percentage_of_job_placement
                    ).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_219, _toDisplayString(Number(
                      info?.trancheInfo
                        ?.Total_upskill_female_percentage_of_job_placement
                    ).toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("tr", _hoisted_220, [
              _hoisted_221,
              _createElementVNode("td", _hoisted_222, _toDisplayString(Number(this.GrandTotalTargetTrainee).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_223, _toDisplayString(Number(
                    this.GrandTotalTargetNewEntrantTrainee
                  ).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_224, _toDisplayString(Number(this.GrandTotalTargetUpskillTrainee).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_225, _toDisplayString(Number(this.GrandTotalEnrollment).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_226, _toDisplayString(Number(this.GrandTotalNewEntrantEnrollment).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_227, _toDisplayString(Number(
                    this.GrandTotalNewEntrantFemaleEnrollment
                  ).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_228, _toDisplayString(Number(this.GrandTotalUpskillEnrollment).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_229, _toDisplayString(Number(
                    this.GrandTotalUpskillFemaleEnrollment
                  ).toLocaleString()), 1),
              _createElementVNode("td", _hoisted_230, _toDisplayString(this.GrandTotalCertificate.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_231, _toDisplayString(this.GrandTotalCertificateNewEntrant.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_232, _toDisplayString(this.GrandTotalCertificateNewEntrantFemale.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_233, _toDisplayString(this.GrandTotalCertificateUpskill.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_234, _toDisplayString(this.GrandTotalCertificateFemaleUpskill.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_235, _toDisplayString(this.GrandTotalJob.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_236, _toDisplayString(this.GrandTotalJobNewEntrant.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_237, _toDisplayString(this.GrandTotalJobNewEntrantFemale.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_238, _toDisplayString(this.GrandTotalJobUpskill.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_239, _toDisplayString(this.GrandTotalJobFemaleUpskill.toLocaleString()), 1),
              _createElementVNode("td", _hoisted_240, _toDisplayString(this.Grand_Total_percentage_of_job_placement.toFixed(2)), 1),
              _createElementVNode("td", _hoisted_241, _toDisplayString(this.Grand_Total_newentrant_percentage_of_job_placement.toFixed(
                    2
                  )), 1),
              _createElementVNode("td", _hoisted_242, _toDisplayString(this.Grand_Total_newentrant_female_percentage_of_job_placement.toFixed(
                    2
                  )), 1),
              _createElementVNode("td", _hoisted_243, _toDisplayString(this.Grand_Total_upskill_percentage_of_job_placement.toFixed(
                    2
                  )), 1),
              _createElementVNode("td", _hoisted_244, _toDisplayString(this.Grand_Total_female_upskill_percentage_of_job_placement.toFixed(
                    2
                  )), 1)
            ])
          ])
        ])
      ])
    ])
  ], 2)), [
    [_directive_loading, _ctx.load]
  ])
}